<template>
  <div id="Dec2023" class="202312 relative">
    <router-link :to="{ name: 'index' }" class="fixed right-0 top-0 w-24 p-3 z-50"><img src="~@/assets/images/202311/source01_logo.png" alt=""></router-link>
    <main class="main">
      <section class="banner z-50 w-full flex items-center">
        <div class="max-w-6xl mx-auto py-5">
          <div class="px-2"><img src="~@/assets/images/202312/banner_01.png" alt=""></div>
          <div><img src="~@/assets/images/202312/banner_02.png" alt=""></div>
        </div>
      </section>
      <section class="section1 z-40 w-full py-5 sm:py-10">
        <div class="max-w-6xl mx-auto py-6 px-4">
          <div class="mb-6 sm:mb-10 relative section1_1">
            <div><img src="~@/assets/images/202312/source02_01.png" alt="">
            </div>
          </div>
          <div class="relative section1_2">
            <div><img src="~@/assets/images/202312/source02_02.png" alt=""></div>
          </div>
        </div>
      </section>
      <section class="section2 z-30 w-full py-5 sm:py-10">
        <a class="mb-8 flex justify-center items-center sm:px-8 banner" href="https://store.liveabc.com/products/magazine/sale?tag=310" target="_blank">
          <div class="max-w-6xl mx-auto"><img src="~@/assets/images/202312/source03_01.png" alt=""></div>
        </a>
        <div class="max-w-6xl mx-auto py-6 px-4">
          <div class="flex flex-wrap mb-12">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="w-full sm:w-1/2 p-3" v-for="(item, index) in bookData1" :key="index">
              <img :src="item.img_url" alt="">
            </router-link>
          </div>
          <a class="book2 rounded-3xl pb-2 px-2 block bg-white" href="https://store.liveabc.com/products/magazine/sale?tag=310" target="_blank">
            <div class="w-3/5 sm:w-1/3 mx-auto" style="height: 20px"><img src="~@/assets/images/202312/source03_bg2.png" alt="" class="img1"></div>
            <div class="flex flex-wrap">
              <div class="w-1/3 sm:w-1/6 p-3" v-for="(item, index) in bookData2" :key="index">
                <img :src="item.img_url" alt="">
              </div>
            </div>
          </a>
        </div>
      </section>
      <section class="section3 z-20 w-full py-5 sm:py-10">
        <div class="max-w-6xl mx-auto py-6 md:py-8 px-4">
          <a class="mb-8 flex items-center" href="https://store.liveabc.com/products/magazine/sale?tag=317" target="_blank">
            <div class="banner02"><img src="~@/assets/images/202312/source04_bg1.png" alt=""></div>
          </a>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 sm:w-1/3 p-4" v-for="(item, index) in bookData3" :key="index">
              <img :src="item.img_url" alt="">
            </router-link>
          </div>
        </div>
      </section>
      <section class="section4 z-0 w-full py-5 sm:pt-16 sm:pb-8">
        <a class="max-w-6xl mx-auto pt-6 pb-12 md:pb-20 px-6 md:px-12 block" href="https://store.liveabc.com/products/magazine/sale?tag=318" target="_blank">
          <div class="rounded-3xl px-3 md:px-6 bg-white content">
            <div class="w-1/2 mx-auto"><img src="~@/assets/images/202312/source05_01.png" alt="" class="imgT_2"></div>
            <div class="mb-8 flex">
              <div class="w-1/3"><img src="~@/assets/images/202312/source05_02.png" alt=""></div>
              <div class="w-1/3"><img src="~@/assets/images/202312/source05_03.png" alt=""></div>
              <div class="w-1/3"><img src="~@/assets/images/202312/source05_04.png" alt=""></div>
            </div>
            <div class=""><img src="~@/assets/images/202312/source05_05.png" alt=""></div>
            <div class="flex">
              <div class="w-1/2"><img src="~@/assets/images/202312/source05_06.png" alt=""></div>
              <div class="w-1/2 relative">
                <div class="absolute bottom-0"><img src="~@/assets/images/202312/source05_07.png" alt=""></div>
              </div>
            </div>
          </div>
        </a>
      </section>
      <section class="section5 z-10 w-full">
        <div class="max-w-6xl mx-auto p-6 pb-24 md:p-10 md:pb-48"><img src="~@/assets/images/202312/source06_01.png" alt=""></div>
      </section>
    </main>
  </div>
</template>
<script>
export default {
  name: 'Dec2023',
  metaInfo () {
    return {
      title: '1212歲末感恩回饋慶!!',
      titleTemplate: null
    }
  },
  data () {
    return {
      renderComponent: false,

      bookData1: [
        { id: 9140, img_url: require('@/assets/images/202312/source03_m1.png') },
        { id: 9136, img_url: require('@/assets/images/202312/source03_m2.png') },
        { id: 9137, img_url: require('@/assets/images/202312/source03_m3.png') },
        { id: 9135, img_url: require('@/assets/images/202312/source03_m4.png') },
        { id: 9138, img_url: require('@/assets/images/202312/source03_m5.png') },
        { id: 9139, img_url: require('@/assets/images/202312/source03_m6.png') }
      ],
      bookData2: [
        { id: 8993, img_url: require('@/assets/images/202312/source03_b1.png') },
        { id: 8993, img_url: require('@/assets/images/202312/source03_b2.png') },
        { id: 8993, img_url: require('@/assets/images/202312/source03_b3.png') },
        { id: 8993, img_url: require('@/assets/images/202312/source03_b4.png') },
        { id: 8993, img_url: require('@/assets/images/202312/source03_b5.png') },
        { id: 8993, img_url: require('@/assets/images/202312/source03_b6.png') }
      ],
      bookData3: [
        { id: 8882, img_url: require('@/assets/images/202312/source04_01.png') },
        { id: 8439, img_url: require('@/assets/images/202312/source04_02.png') },
        { id: 7823, img_url: require('@/assets/images/202312/source04_03.png') },
        { id: 7385, img_url: require('@/assets/images/202312/source04_04.png') },
        { id: 8994, img_url: require('@/assets/images/202312/source04_05.png') },
        { id: 7524, img_url: require('@/assets/images/202312/source04_06.png') }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
#Dec2023 {
  .banner {
    background-image: url('~@/assets/images/202312/banner_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #912210;
    background-position: center;
  }
  .section1 {
    background-color: #011945;
    .people1 {
      left: -5%;
    }
    .people2 {
      right: -5%;
    }
  }
  .section2 {
    background-color: #912210;
    .banner {
      background-image: url('~@/assets/images/202312/source03_bg.png');
      background-repeat: no-repeat;
      background-size: contain;

      background-position: bottom center;
    }
    // .book2 {
    //   background-color: #360000;
    // }
    .img1 {
      transform: translateY(-50%);
      // margin-top: -50%;
    }
  }
  .section3 {
    background-color: #216142;
    .banner02 {
      background-image: url('~@/assets/images/202312/source04_bg2.png');
      background-repeat: no-repeat;
      background-size: contain;

      background-position: bottom center;
    }
    .imgT_1 {
      transform: translateX(-2%);
    }
  }
  .section4 {
    .content {
      background-image: url('~@/assets/images/202312/source05_bg.png');
      background-repeat: no-repeat;
      background-size: 15%;

      background-position: top right;
    }

    background-color: #001945;
    .imgT_2 {
      transform: translateY(-50%);
    }
    .imgT_3 {
      transform: translateY(60%);
    }
  }
  .section5 {
    background-image: url('~@/assets/images/202312/source06_bg.png');
    background-repeat: no-repeat;
    background-size: contain;

    background-position: bottom center;
    background-color: #001945;
  }
}
</style>
